export const GLOBAL_CONSTANTS = {
  FORGOT_PWD: "Forgot Password?",
  COUNTRY_CODE: "+91",
  COMPLETE_KYC_TXT: "Complete KYC Verification",
  KYC_UNDER_REVIEW_TXT:
    "KYC under review. You will be notified once it's done!",
  SLA_NOT_SIGNED_TXT: "SLA is not Signed",
  STAT_PEN_ID: "USM1000007",
  STAT_KYC_PEN_ID: "USM1000008",
  STAT_KYC_REVIEW_ID: "USM1000010",
  STAT_KYC_VERIFIED_ID: "USM1000009",
  STAT_ACTIVE_ID: "USM1000001",
  SUCCESS: "success",
  NAME_AS_PER_PAN: "Contact Name",
  PH_NUM: "Poc Phone Number",
  PRIM_ADD: "Primary Address",
  COMM_ADD: "Address for Communication",
  NA: "Not Available",
  NV: "Not Verified",
  COMP_NAME: "Business Name",
  COMP_EMAIL: "Company Email",
  COMP_PH_NUM: "Company Phone Number",
  COMP_PAN: "Company PAN",
  COMP_GSTIN: "Company GSTIN",
  COMP_BANK_ACC: "Company Bank Account",
  COMP_REG_ADD: "Business Registered Address",
  COMP_TYPE: "Business Type",
  DIR_NAME: "Director Name",
  DIR_EMAIL: "Director Email",
  DIR_PH_NUM: "Director Phone Number",
  DIR_PAN: "Director PAN",
  DIR_AADHAR: "Director Aadhar",
  DESIG: "Designation",
  IND_TYPE: "Industry Type",
  ANN_TURN: "Annual Turnover",
  DOB: "Date of Birth",
  KAR_NAME: "Karta Name",
  KAR_EMAIL: "Karta Email",
  KAR_PH_NUM: "Karta Phone Number",
  KAR_PAN: "Karta PAN",
  HUF_NAME: "HUF Name",
  HUF_EMAIL: "HUF Email",
  HUF_PH_NUM: "HUF Phone Number",
  HUF_REG_ADD: "HUF Registered Address",
  HUF_PAN: "HUF PAN",
  ACC_NUM: "Account Number",
  ACC_HOL_NAME: "Account Holder Name",
  ACC_IFSC: "Account IFSC",
  BRA_NAME: "Branch Name",
  PRIM_BANK: "PRIMARY BANK",
  PAN: "PAN",
  AADHAR: "Aadhar",
  BANK_ACC: "Bank Account",
  SLA: "SLA",
  NOM_LEG_NAME: "Nominee Legal Name",
  NOM_DOB: "Nominee Date of Birth",
  RELSHIP: "Relationship",
  WEBSITE: "Website",
  CREDIT_TENURE: "Credit Tenure",
  CREDIT_AMT: "Requested Credit Amount",
  INC_DATE: "Incorporation Date",
  MULTIPLE_GST: "Has Multiple GSTIN?",
  BUS_DESC: "Business Description",
  FIN_SUMMARY: "Financial Summary",
  COMMENTS: "Comments",
  DEL: "Delete",
  TENURE: "Tenure",
  INVO_FILE: "InvoiceFile",
  TERMS: "Terms",
  PRIVACY: "Privacy",
  NO_ROLES: "No Roles",
  NO_PERMISSIONS: "No Permissions",
  INVO_FOR_ENT: "Enterprise",
  INVO_FOR_BUS: "Business",
  PDF: "PDF",
  ZIP: "ZIP",
  PDF_ZIP: "PDF, ZIP",
  IMAGETYPE: "JPG, PNG, JPEG, WEBP",
  XLSX: "XLSX",
  VERIFIED: "Verified",
};

export const BTN_TXT = {
  ACTIVATE_USER: "Activate User",
  ADD_NEW_ENQ: "Add New Enquiry",
  ADD_ROLE: "Add Role",
  ADD_USER: "Add User",
  ASSIGN: "Accept",
  APPROVE: "Approve",
  ASSIGN_RM: "Assign Relationship Manager",
  BACK: "Back",
  BANK_DET: "Bank Details",
  BLACKLIST: "Blacklist",
  CANCEL: "Cancel",
  CHANGE: "Change",
  CHNG_PWD: "Change Password",
  SEND_QUERY: "Send Questionnaire",
  COM_KYC: "Complete KYC",
  COMPLETE_NOW: "Complete Now",
  SEND_KYC_LINK: "Send KYC Link",
  CREATE: "Create",
  DEACTIVATE: "Deactivate",
  DELINQUENT: "Delinquent",
  DE_SELECT_ROLES: "De-select All Roles",
  DWNLD_SUM_TEMP: "Download Summary Template",
  EDIT: "Edit",
  EDIT_ROLE: "Edit Role",
  LOGIN: "Login",
  LOGOUT: "Logout",
  MORE: "More",
  NEXT: "Next",
  PROFILE: "Profile",
  REACTIVATE: "Reactivate",
  ACTIVATE: "Activate",
  READ_LESS: "Read Less",
  READ_MORE: "Read More",
  RE_ASSIGN: "Re-Assign",
  RE_ASSIGN_RM: "Re-Assign RM",
  REJECT: "Reject",
  RESEND: "Resend",
  REOPEN: "Reopen",
  RESET_MFA: "Reset MFA",
  REVIEW_KYC: "Review KYC",
  SAVE: "SAVE",
  SAVE_ADD: "Save Address",
  SAVE_CHNG: "Save Changes",
  SELECT_ROLES: "Select All Roles",
  SEND_OTP: "Send OTP",
  SIGNUP: "Sign Up",
  SIGN_SLA: "Sign SLA",
  SKIP: "Skip",
  SUBMIT: "Submit",
  SAVE_QUESTION_BUS: "Save (This Business Only)",
  SAVE_QUESTION_PUBLIC: "Save",
  UPLOAD_DOC_ZIP: "Upload Documents ZIP",
  UPLOAD_INV: "Upload Invoice",
  UPLOAD_SCF: "Upload Document",
  UPLOAD_SUM_FILE: "Upload Summary File",
  VALIDATE_SUM: "Validate Summary",
  ADD_NEW_ENTERPRISE: "Add Enterprise",
  ADD_NEW_CREDIT_LIMIT: "Add Business Enterprise Relationship",
  SEND_KYC_REMINDER: "Send KYC Reminder",
  REVIEW_MANUAL_KYC: "Review Manual KYC",
  ENHANCE: "Enhance",
  VERIFY_OTP: "Verify OTP",
  VERIFY: "Verify",
  VERIFIED: "Verified",
  VIEW: "View",
  VIEW_ALL: "View All",
  CLICK_HERE: "Click here",
  TO_VIEW_DETAILS: "to view the details",
  PRO_WITH_DIGI: "Proceed with Digilocker",
  FETCH_AADHAAR_PAN: "Fetch Aadhaar & PAN",
  UPLOAD: "Upload",
  REUPLOAD: "Re-Upload",
  DELETE: "Delete",
  DWNLD_FILE: "Download File",
  DOWNLOAD: "Download Invoice",
  DWNLD_INV_CSV: "Download Invoices CSV",
  DWNLD_INV_ZIP: "Download Invoices Zip",
  DWNLD_PO_CSV: "Download Purchase Order CSV",
  DWNLD_PO_ZIP: "Download Purchase Order Zip",
  SETTLE_SEL_DEAL: "Settle Selected deals",
  RESEND_OTP: "Resend OTP",
  VIEW_BR: "View BR",
  CRD_ASS: "Credit Assessment",
};

export const KYC_VERIFICATION_MODE = {
  MANUAL: "MANUAL",
  HYBRID: "HYBRID",
  DIGITAL: "DIGITAL",
};

export const INVESTOR_TYPE_NAME = {
  INDIVIDUAL: "Individual",
  HUF: "HUF",
  ENTITY: "Entity",
  NBFC: "NBFC",
};

export const INVESTOR_TYPE_ID = {
  INDIVIDUAL: "UTY1000001",
  HUF: "UTY1000002",
  ENTITY: "UTY1000006",
  NBFC: "UTY1000008",
};

export const INVESTOR_TYPE_ID_TO_NAME = {
  [INVESTOR_TYPE_ID.INDIVIDUAL]: INVESTOR_TYPE_NAME.INDIVIDUAL,
  [INVESTOR_TYPE_ID.HUF]: INVESTOR_TYPE_NAME.HUF,
  [INVESTOR_TYPE_ID.ENTITY]: INVESTOR_TYPE_NAME.ENTITY,
  [INVESTOR_TYPE_ID.NBFC]: INVESTOR_TYPE_NAME.NBFC,
};

/** Investor types that may show View BR in pending KYC actions */
export const BOARD_RESOLUTION_INVESTOR_TYPES = [
  INVESTOR_TYPE_NAME.ENTITY,
  INVESTOR_TYPE_NAME.NBFC,
];

export const MANUAL_KYC_STEP_STATUS = {
  PENDING: "PENDING",
  SUBMITTED: "SUBMITTED",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
  NOT_APPLICABLE: "NOT_APPLICABLE",
};

export const DOC_MASTER_ID = {
  PAN_CARD: "DMS1000001",
  GST_CERT: "DMS1000002",
  AADHAAR: "DMS1000005",
  DL: "DMS1000006",
  PASSPORT: "DMS1000008",
  SELFIE: "DMS1000009",
  BANK_PROOF: "DMS1000013",
  BANK_STATEMENT: "DMS1000019",
  DIRECTOR_PHOTO: "DMS1000022",
  DIRECTOR_PAN_VALUE: "DMS1000023",
  DIRECTOR_AADHAAR_VALUE: "DMS1000024",
  PAN_VALUE: "DMS1000025",
  PAN_DOC: "DMS1000026",
  GSTIN_VALUE: "DMS1000027",
  GSTIN_DOC: "DMS1000028",
  DIRECTOR_PAN_DOC: "DMS1000029",
  DIRECTOR_AADHAAR_DOC: "DMS1000030",
  VOTER_ID: "DMS1000051",
  COMPANY_PAN: "DMS1000056",
};

export const MANUAL_KYC_REVIEW_DOC_LABELS = {
  [DOC_MASTER_ID.PAN_CARD]: "PAN Card Document",
  [DOC_MASTER_ID.DIRECTOR_PAN_VALUE]: "Director / Karta PAN",
  [DOC_MASTER_ID.DIRECTOR_AADHAAR_VALUE]: "Director / Karta Aadhaar",
  [DOC_MASTER_ID.PAN_VALUE]: "PAN Card Value",
  [DOC_MASTER_ID.PAN_DOC]: "PAN Card Document",
  [DOC_MASTER_ID.GSTIN_VALUE]: "GSTIN Value",
  [DOC_MASTER_ID.GSTIN_DOC]: "GST Certificate",
  [DOC_MASTER_ID.DIRECTOR_PAN_DOC]: "Director / Karta PAN Document",
  [DOC_MASTER_ID.DIRECTOR_AADHAAR_DOC]: "Director / Karta Aadhaar Document",
  [DOC_MASTER_ID.AADHAAR]: "Aadhaar Document",
  [DOC_MASTER_ID.SELFIE]: "Live Selfie Photo",
  [DOC_MASTER_ID.DIRECTOR_PHOTO]: "Live Selfie Photo",
  [DOC_MASTER_ID.BANK_PROOF]: "Bank Proof / Cancelled Cheque",
  [DOC_MASTER_ID.BANK_STATEMENT]: "Bank Statement",
};

export const MANUAL_KYC_MSG = {
  LOAD_FAILED: "Failed to load applicant KYC details.",
  APPROVE_FAILED: "Failed to approve manual KYC step.",
  REJECT_FAILED: "Failed to reject manual KYC step.",
  REJECT_REASON_REQUIRED: "Please enter a valid rejection reason.",
  REJECT_DEFAULT_REMARK: "Rejected during review",
  NO_DOCS: "No documents submitted for this step.",
  PLACEHOLDER: "N/A",
  VIEW_PDF: "View PDF",
  CONFIRM_REJECTION: "Confirm Rejection",
  APPROVE_SUCCESS: (step) => `Step ${step || 1} approved successfully!`,
  REJECT_SUCCESS: (step) => `Step ${step} rejected successfully!`,
  APPROVE_STEP: (step) => `Approve Step ${step}`,
  REJECT_STEP: (step) => `Reject Step ${step}`,
};

export const TITLE_TXT = {
  APPROVE_ENT_BUS: "Approve Business Enterprise Relationship",
  WELCOME_TEXT: "Welcome to Karncy",
  OTP_TITLE: "Enter the OTP",
  CHNG_PWD_TITLE: "Change Password",
  INV: "Investor",
  ECW_BEN_ACC_NAME: "Beneficiary Account Name",
  ECW_BANK_NAME: "Virtual Account Bank Name",
  ECW_BRANCH_NAME: "Virtual Account Branch Name",
  ECW_BANK_ACC_NUM: "Virtual Account Number",
  ECW_IFSC_CODE: "Virtual Account IFSC Code",
  CONTACT_DETS: "Contact Details",
  BUS_DETS: "Business Details",
  ECW_DETS: "Virtual Account Details",
  USER_DETS: "User Details",
  KAR_DETS: "Karta Details",
  COMP_DETS: "Company Details",
  NBFC_DETS: "NBFC Details",
  AUTH_SIG: "Company Details",
  HUF_DETS: "HUF Details",
  BANK_DETS: "Bank Details",
  BANK_KYC_DETS: "Bank & KYC",
  ADD_NEW_BANK_DETS: "Add New Bank Details",
  KYC_DETS: "KYC Details",
  NOM_DETS: "Nominee Details",
  ADD_NOM_DETS: "Add Nominee Details",
  EDIT_NOM_DETS: "Edit Nominee Details",
  BUS_ENT_ESCW_ACC_DETS: "Business Enterprise Virtual Account Details",
  INV_UPLOAD: "Invoice Upload",
  INV_UPLOAD_STEP_1: "STEP 1 - Upload Invoice Summary Sheet",
  PO_UPLOAD: "Purchase Order Upload",
  PO_UPLOAD_STEP_1: "STEP 1 - Upload Purchase Order Summary Sheet",
  DOC_SUB_SUC: "Documents Submitted Successfully",
  DEALS: "Deals",
  TQ: "Thank you!",
  SETTLEMENT: "Settlement",
  USERS_LIST: "USERS LIST",
  EDIT_USER: "Edit User",
  CREATE_USER: "Create User",
  PERM_LIST: "PERMISSIONS LIST",
  RM_LIST: "RELATIONSHIP MANAGERS LIST",
  ASSIGN_RM: "Assign Relationship Manager",
  RE_ASSIGN_RM: "Re-Assign Relationship Manager",
  DEACTIVATE_CONFIRM: "Deactivate Confirmation",
  BLACKLIST_CONFIRM: "Blacklist Confirmation",
  DELINQUENT_CONFIRM: "Delinquent Confirmation",
  CANCEL: "Cancel Confirmation",
  DISBURSE_CONFIRM: "Disburse Confirmation",
  ROLES_LIST: "ROLES LIST",
  CREATE_ROLE: "Create Role",
  EDIT_ROLE: "Edit Role",
  PERM: "Permissions",
  SEL_PERM: "Selected Permissions",
  ROLE_DETS: "ROLE DETAILS",
  ADD_NEW_ENQ: "Add New Enquiry",
  ADD_NEW_ENTERPRISE: "Add Enterprise",
  ADD_NEW_CREDIT_LIMIT: "Add Business Enterprise Relationship",
  ASSIGN_CONFIRM: "Assign Confirmation",
  REJECT_CONFIRM: "Reject Confirmation",
  REOPEN_CONFIRM: "Reopen Confirmation",
  ACTIVATE_CONFIRM: "Activate Confirmation",
  ADD_VERIFY: "Address verification",
  PRIM_ADD: "Primary Address",
  COMM_ADD: "Communication Address",
  BANK_VERIFY: "Bank Verification",
  ADDITIONAL_INFO: "Additional Information",
  DIR_KYC: "Director KYC",
  EMAIL_OTP_VERIFY: "Email OTP Verification",
  MOBILE_OTP_VERIFY: "Mobile OTP Verification",
  UPLOAD_DOCS: "Upload Documents",
  DIR_DETS: "Director",
  DOCS: "Documents",
  DIR_AADHAAR: "Director(s) Aadhaar",
  DIR_PAN: "Director(s) PAN",
  GSTIN_CERT: "GSTIN Certificate",
  BANK_STMT_12_MON: "Bank statement for last 12 months",
  AUD_REPORTS_3_YEARS:
    "Audited financial statements and Audit Report for last 3 years",
  SANC_LETTER: "Sanction letter of all existing borrowings",
  PROV_STMT: "Provisional Financial statements for the latest year",
  GST_RETURNS_12_MON: "GST returns of company for last 12 months",
  ITR_2_YEARS: "ITR for the last two years of Company",
  DIR_PHOTO: "Director Photo",
  OTHER_DOCS: "Other Documents",
  CERT_INCORP: "Certificate of Incorporation",
  COMP_PAN: "Company Pan Card",
  BOARD_RESOL:
    "Board Resolution certifying authorised signatory/signatories with signs of Directors/Director and CS",
  KYC_DOCS: "KYC documents of the Authorized signatory/signatories",
  CURR_SHARE_PATTERN: "Current Shareholding Pattern",
  MEMO_ARTICLE: "Memorandum and Articles of Association",
  SOLE_PROP:
    "Sole Proprietor Declaration or Partnership Deed evidencing the constitution of the company",
  STATUTORY_REQ:
    "Statutory requirements like registration certificate and Power of Attorney granted to a partner or an employee of the firm to transact business on its behalf",
  SHOPS_EST: "Shops & Establishments Act",
  FIN_EVAL: "Financial Evaluation",
  PAN_CERT: "PAN Certificate",
  ENT_LOGO: "Enterprise Logo",
  MOU_SIGN: "MOU Signed",
  SANCTION_DOCS: "Sanction Documents",
  FIN_SUMMARY: "Financial Summary",
  RATIOS: "Ratios",
  APPROVE_ENT: "Approve Enterprise",
  ENT_DETS: "Enterprise",
  SUPPLIERS_LIST: "Suppliers List",
  BUSENT_DETS: "Business - Enterprise Relationship Details",
  EDIT_COM_ADD: "Edit Communication Address",
  PRIM_BANK_DETS: "Primary Bank Details",
  SEC_BANK_DETS: "Secondary Bank Details",
  ECW_BANK_DETS: "Virtual Account Bank Details",
  VA_BANK_DETS: "Virtual Account Details",
  INV_DETS: "Investor Details",
  CONS_LET: "Consent Letter",
  DEAL_DETS: "Deal Details",
  DEAL_LEVEL_FUND: "Deal Level Funding",
  DEAL_LEVEL_SETTLE: "Deal Level Settlement",
  ACTIVITY_LOG: "Activity Log",
  CREATE_NEW_DIS: "Create New Dispute",
  CREATE_NEW_ESC: "Create New Escalation",
  RESOLVE_DIS: "Resolve Dispute",
  TRANSC_SUM: "Transaction Summary",
};

export const INV_TEMP_COL = [
  { header: "Invoice Number", key: "invNum" },
  { header: "Invoice Amount", key: "invAmt" },
  { header: "Invoice Date", key: "invDate" },
  { header: "Invoice Due Date", key: "invDueDate" },
];

export const DESC_TXT = {
  FORGOT_PWD_INFO_TEXT:
    "Enter your user account's verified email address and we will send an otp to that email.",
  OTP_INFO_TEXT:
    "If you have not received the OTP in your inbox, please check your Junk/Spam folder as well.",
  BANK_DETS_NOT_AVAIL: "Bank details not available",
  ECW_DETS_NOT_AVAIL: "Virtual Account details not available",
  INV_UPLOAD_STEP_1:
    "Submit invoice details in Excel (XLSX) or CSV format using the sample template.",
  PO_UPLOAD_STEP_1:
    "Submit Purchase Order details in Excel (XLSX) or CSV format using the sample template.",
  DOC_SUB_SUC:
    "Your invoice summary and supporting documents have been submitted. We will review your request and notify you shortly regarding the next steps.",
  PO_DOC_SUB_SUC:
    "Your purchase order summary and supporting documents have been submitted. We will review your request and notify you shortly regarding the next steps.",
  DEACTIVATE_RM:
    "You can only deactivate a RM when there are no users assigned to them, Please reassign the users from current RM before deactivating.",
  UPLOAD_DOC_DESC: "File size should be max 20 MB, Accepted files:",
  POC_DIRECTOR_NOTE:
    "The POC Name, POC Phone Number, and POC Email ID must be the details of a Director of the business.",
};

export const SUCCESS_MSGS = {
  ECW_DET_SUC_MSG: "Virtual Account details sent to registered email Sucessfully!",
};

export const ERROR_MSGS = {
  SESSION_ELSEWHERE:
    "You have been logged out because your account was signed in elsewhere.",
  EMAIL_ERR_MSG: "Email cannot be empty!",
  PWD_ERR_MSG: "Password cannot be empty!",
  DESIGNATION_ERR_MEG: "Designation cannot be empty!",
  BANK_KYC_ERR_MSG: "Please Complete your bank verification later",
  ENTER_CURR_PWD_ERR_MSG: "Please enter your current password!",
  ACC_NUM_ERR_MSG: "Account numbers do not match!",
  ACCP_CONCENT_ERR_MSG: "You must agree to the consent letter!",
  ENTER_NOM_DOB: "Please enter Nominee DOB!",
  SEL_REL: "Please select your relationship!",
  ACCP_TER_CON: "You must accept the terms and conditions!",
  SEL_STATE: "Please select State!",
  SEL_IND_TYPE: "Please select Industry Type!",
  SEL_ANN_TURN: "Please select Annual Turnover!",
  SEL_COMP_TYPE: "Please select Company type!",
  BUS_DESCRIPTION_ERR_MSG: "Business Description Cannot be empty!",
  FINANCIAL_SUMMARY: "Financial Summary Cannot be empty!",
  COMMENTS: "Comments Cannot be empty!",
  SEL_ORG_ERR_MSG: "Please select organization",
  SEL_ROLE_ERR_MSG: "Please select at least one role",
  SEL_RM_ERR_MSG: "Please select an RM",
  EXP_AMT_ERR_MSG: "Expected amount cannot be empty!",
  EXPOSURE_AMT_ERR_MSG: "Exposure amount cannot be empty!",
  PRE_CRED_ERR_MSG: "Previous Credit Limit cannot be empty!",
  EXP_CRED_ERR_MSG: "Expected Credit Limit cannot be empty!",
  APPRO_CRED_ERR_MSG: "Approved Credit Limit cannot be empty!",
  ENHANCE_CRED_ERR_MSG: "Enhanced Credit Limit cannot be empty!",
  MAX_FUND_REQ_PCT_ERR_MSG: "Max Fund Required % cannot be empty!",
  SEL_LOC_ERR_MSG: "Please select a location",
  SEL_DEAL_TYPE_ERR_MSG: "Please select Deal Type",
  ENTER_INC_DATE: "Please select Incorporation Date",
  ADD1_ERR_MSG: "Address 1 cannot be empty!",
  ADD2_ERR_MSG: "Address 2 cannot be empty!",
  CITY_ERR_MSG: "City cannot be empty!",
  STATE_ERR_MSG: "State cannot be empty!",
  PIN_ERR_MSG: "Pincode cannot be empty!",
  SEL_RATE_ERR_MSG: "Please select rating",
  SEL_EXP_DAYS_ERR_MSG: "Please select Expiry Days",
  SEL_VISI_ERR_MSG: "Please select Deal Visibility",
  SEL_LINE_BUS_ERR_MSG: "Please select Line of Business",
  DIS_DATE_ERR_MSG: "Please select Dispute Date",
  SEL_DIS_TYPE_ERR_MEG: "Please select Dispute Type",
  DIS_AMT_ERR_MSG: "Dispute Amount cannot be empty!",
  AMT_ERR_MSG: "Amount cannot be empty!",
  SEL_DIS_PRI_ERR_MSG: "Please select Dispute Priority",
  SEL_DIS_REA_ERR_MSG: "Please select Dispute Reason",
  DIS_REA_ERR_MSG: "Dispute Reason cannot be empty!",
  SEL_DIS_RAISE_FOR_ERR_MSG: "Please select Dispute Raised For",
  SEL_USER_ERR_MSG: "Please select User",
  SEL_RES_TYPE_ERR_MSG: "Please select Resolution Type",
  SEL_RES_REASON_ERR_MSG: "Please select Resolution Reason",
  SEL_ASS_RM_FOR_ERR_MSG: "Please select one option",
  OTP_ERR_MSG: "OTP cannot be empty!",
  SEL_RM_MAN_ERR_MSG: "Please select Regional Manager",
  MEET_DATE_ERR_MSG: "Please select Meeting Date",
  MEET_TIME_ERR_MSG: "Please select Meeting Time",
  MEETING_PLATFORM_ERR_MSG: "Please select Meeting Platform",
};

export const CREDIT_LIMIT_SUPER_ADMIN_THRESHOLD = 2500000;

export const CREDIT_LIMIT_MSGS = {
  RELATION_ADDED: "{business} - {enterprise} Relation Added successfully",
  FAILED_ADD_RELATION: "Failed to add {business} - {enterprise} Relation",
  APPROVED: "{business} - {enterprise} Approved Successfully",
  FAILED_APPROVE: "Failed to Approve {business} - {enterprise}",
  ACTION_FAILED: "Failed to {action} {business} - {enterprise}",
  ACTION_SUCCESS: "{business} - {enterprise} {actionLabel} Successfully",
  ENHANCE_SUCCESS: "Credit Limit for the {business} - {enterprise} Enhanced Successfully",
  ENHANCE_FAILED: "Failed to Enhance Credit Limit for {business} - {enterprise}",
  DOWNLOAD_FAILED: "Unable to Download file",
  SUPER_ADMIN_ONLY: "Credit limits above ₹25 lakhs can only be approved by a Super Admin. Please contact your Super Admin to complete this approval.",
  SUPER_ADMIN_ONLY_TITLE: "Approval Restricted",
  BUSINESS_MUST_BE_ACTIVE: "The business must be in Active before the credit limit can be activated.",
  BUSINESS_MUST_BE_ACTIVE_TITLE: "Cannot Reactivate Credit Limit",
};

export const LABEL_TXT = {
  ENT_NAME: "Enterprise Name",
  BUS_NAME: "Business Name",
  IND_TYPE: "Industry Type",
  BUS_TYPE: "Business Type",
  ANN_TURN: "Annual Turnover",
  POC_NAME: "POC Name",
  POC_DESIG: "POC Designation",
  POC_PHONE: "POC Phone Number",
  POC_EMAIL: "POC Email",
  CONT_NAME: "Contact Name",
  DESIG: "Designation",
  INV_TYPE: "Investor Type",
  CONT_PHONE: "Contact Phone Number",
  CONT_EMAIL: "Contact Email",
  CRED_TEN: "Credit Tenure(in Days)",
  REQ_CRED_AMT: "Requested Credit Amount",
  AMT_TO_RAISE: "Amount To Raise",
  OTHERS: "Others Terms & Conditions",
  Deal_DETAILS: "Deal Details",
  PITCH: "Deal Upload Document",
  HAS_MUL_GST: "Has Multiple GSTIN?",
  DEAL_CAT: "Deal Category",
  PAN: "PAN",
  GSTIN: "GSTIN",
  ENT_WEB: "Enterprise Website",
  BUS_WEB: "Business Website",
  INC_DATE: "Incorporation Date",
  ENT_DESC: "Enterprise Description",
  EXP_AMT: "Enterprise Exposure Amount",
  BUS_DESC: "Business Description",
  FIN_SUM: "Financial Summary",
  COMMENTS: "Comments",
  ADDITIONAL_REF_LINKS: "Additional Reference Links",
  ADD1: "Address 1",
  ADD2: "Address 2",
  CITY: "City",
  PIN: "Pincode",
  STATE: "State",
  ACC_HOL_NAME: "Account Holder Name",
  ACC_NUM: "Account Number",
  ACC_IFSC: "Account IFSC",
  BANK_NAME: "Bank Name",
  BRANCH_NAME: "Branch Name",
  ECW_BEN_ACC_NAME: "Beneficiary Account Name",
  ECW_BANK_NAME: "Virtual Account Bank Name",
  ECW_BRANCH_NAME: "Virtual Account Branch Name",
  ECW_BANK_ACC_NUM: "Virtual Account Number",
  ECW_IFSC_CODE: "Virtual Account IFSC Code",
  VA_ACC_NUM: "VA Account Number",
  VA_IFSC_CODE: "VA IFSC Code",
  VA_BANK_NAME: "VA Bank Name",
  VA_BRANCH_NAME: "VA Branch Name",
  VA_BEN_ACC_NAME: "VA Beneficiary Name",
  BANK: "Bank",
  DIR_NAME: "Director Name",
  DIR_PAN: "Director PAN",
  DIR_AADHAR: "Director Aadhar",
  DIR_PIC: "Director Picture",
  NOM_NAME: "Nominee Name",
  DOB: "Date of Birth",
  NOM_PH_NUM: "Nominee Phone Number",
  RELATION: "Relation",
  AADHAR: "Aadhar",
  SLA: "SLA",
  KAR_NAME: "Karta Name",
  KAR_EMAIL: "Karta Email",
  KAR_PH_NUM: "Karta Phone Number",
  COMP_NAME: "Company Name",
  NBFC_NAME: "NBFC NAME",
  COMP_EMAIL: "Company Email",
  NBFC_EMAIL: "NBFC Email",
  COMP_PH_NUM: "Company Phone Number",
  NBFC_PH_NUM: "NBFC Phone Number",
  COMP_TYPE: "Company Type",
  HUF_NAME: "HUF Name",
  HUF_EMAIL: "HUF Email",
  HUF_PH_NUM: "HUF Phone Number",
  COMP_PAN: "Company PAN",
  NBFC_PAN: "NBFC PAN",
  COMP_GSTIN: "Company GSTIN",
  NBFC_GSTIN: "NBFC GSTIN",
  COMP_BANK_ACC: "Company Bank Account",
  NBFC_BANK_ACC: "NBFC Bank Account",
  KAR_PAN: "Karta PAN",
  KAR_AADHAAR: "Karta Aadhaar",
  HUF_PAN: "HUF PAN",
  DEAL_STATUS: "Deal Status",
  DEAL_ID: "Deal ID",
  PRE_CRED: "Previous Credit (Offline if any)",
  APP_CRED: "Approved Credit Limit",
  ANN_DIS_RATE: "Annual Interest Rate (%)",
  MAX_FUND_REQ_PCT: "Max Fund Required (%)",
  CONS_LET: "Consent Letter",
  SANCTION_DOCS: "Sanction Documents",
  PLAT_FEE_RATE: "Platform Fee Rate (%)",
  STAMP_FEE: "Stamp Fee",
  MISC_FEE: "Miscellaneous Fee",
  PENAL_CHARGES: "Penal Charges (%)",
};

export const MEETING_PLATFORMS = [
  {
    label: "Google Meet",
    value: "Google Meet",
  },
  {
    label: "Zoom",
    value: "Zoom",
  },
  {
    label: "Microsoft Teams",
    value: "Microsoft Teams",
  },
];

export const INV_TEMP_DATA = [
  {
    invNum: "INV123456",
    invAmt: 200000,
    invDate: "2023-10-23",
    invDueDate: "2023-10-26",
  },
  {
    invNum: "INV456123",
    invAmt: 500000,
    invDate: "2023-11-01",
    invDueDate: "2023-11-04",
  },
];

export const SCF_TEMP_COL = [
  { header: "PO Number", key: "poNum" },
  { header: "PO Amount", key: "poAmt" },
  { header: "Material Cost", key: "matCost" },
  { header: "PO Date", key: "poDate" },
  { header: "PO Due Date", key: "poDueDate" },
];

export const SCF_TEMP_DATA = [
  {
    poNum: "PO123456",
    poAmt: 200000,
    matCost: 150000,
    poDate: "2023-10-23",
    poDueDate: "2023-10-26",
  },
  {
    poNum: "PO456123",
    poAmt: 500000,
    matCost: 400000,
    poDate: "2023-11-01",
    poDueDate: "2023-11-04",
  },
];

export const YESORNO = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const ASSIGNRMFOR = [
  { label: "Investor", value: "investor" },
  { label: "Business", value: "business" },
];

export const ROLE_COLORS = {
  super_admin: "#00512F",
  admin: "#00874F",
  business: "#1B3591",
  investor: "#006C3F",
};

export const ROLE_STYLES = {
  admin: { color: "#fff", background: "#00874F", borderColor: "#00874F" },
  super_admin: { color: "#fff", background: "#00512F", borderColor: "#00512F" },
  investor: {
    color: "#006C3F",
    background: "transparent",
    borderColor: "#006C3F",
  },
  business: {
    color: "#1B3591",
    background: "transparent",
    borderColor: "#1B3591",
  },
  default: {
    color: "#40566D",
    background: "transparent",
    borderColor: "#40566D",
  },
};

export const FILLED_ROLES = ["admin", "super_admin"];

export const ROLE_IDS = {
  SUPER_ADMIN_ROLE_ID: "ROL1000001",
  NEW_SUPER_ADMIN_ROLE_ID: "ROL1000018",
  INV_ROLE_ID: "ROL1000003",
  BUS_ROLE_ID: "ROL1000004",
};

/** Root User (display name) is the Super Admin role in this product. */
export const isRootOrSuperAdmin = (user = {}) => {
  if (user?.roleId === ROLE_IDS.SUPER_ADMIN_ROLE_ID || user?.roleId === ROLE_IDS.NEW_SUPER_ADMIN_ROLE_ID) return true;
  const normalized = String(user?.roleName || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, " ");
  return normalized === "super admin" || normalized === "root user";
};

/** True only for Root User (ROL1000001), not Super Admin (ROL1000018). */
export const isRootUser = (user = {}) => {
  if (user?.roleId === ROLE_IDS.SUPER_ADMIN_ROLE_ID) return true;
  const normalized = String(user?.roleName || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, " ");
  return normalized === "root user";
};

export const STATUS = {
  ACTIVE: {
    ID: "USM1000001",
    NAME: "ACTIVE",
  },
  INACTIVE: {
    ID: "USM1000002",
    NAME: "INACTIVE",
  },
  DELINQUENT: {
    ID: "USM1000004",
    NAME: "DELINQUENT",
  },
  DEACTIVATED: {
    ID: "USM1000005",
    NAME: "DEACTIVATED",
  },
  KYC_REVIEW: {
    ID: "USM1000010",
    NAME: "KYC_REVIEW",
  },
  REJECTED: {
    ID: "USM1000006",
    NAME: "REJECTED",
  },
  PENDING: {
    ID: "USM1000007",
    NAME: "PENDING",
  },
  KYC_VERIFIED: {
    ID: "USM1000009",
    NAME: "KYC_VERIFIED",
  },
  KYC_PENDING: {
    ID: "USM1000008",
    NAME: "KYC_PENDING",
  },
  BLACKLISTED: {
    ID: "USM1000011",
    NAME: "BLACKLISTED",
  },
  REOPENED: {
    ID: "USM1000012",
    NAME: "REOPENED",
  },
};

export const ENT_STATUS = {
  PENDING: {
    ID: "USM1000001",
    NAME: "PENDING",
  },
  ACTIVE: {
    ID: "USM1000002",
    NAME: "ACTIVE",
  },
  REJECTED: {
    ID: "USM1000003",
    NAME: "REJECTED",
  },
  DEACTIVATED: {
    ID: "USM1000004",
    NAME: "DEACTIVATED",
  },
  RESTRICTED: {
    ID: "USM1000005",
    NAME: "RESTRICTED",
  },
  BLACKLISTED: {
    ID: "USM1000006",
    NAME: "BLACKLISTED",
  },
  REOPENED: {
    ID: "USM1000007",
    NAME: "REOPENED",
  },
};

export const DEAL_STATUS = {
  PENDING: {
    ID: "DSC1000001",
    NAME: "Pending",
  },
  APPROVED: {
    ID: "DSC1000002",
    NAME: "Approved",
  },
  FUNDED: {
    ID: "DSC1000005",
    NAME: "Funded",
  },
  DISBURSED: {
    ID: "DSC1000006",
    NAME: "Disbursed",
  },
  PARTIALLY_SETTLED: {
    ID: "DSC1000009",
    NAME: "Partially Settled",
  },
  SETTLED: {
    ID: "DSC1000010",
    NAME: "Settled",
  },
  CLOSED: {
    ID: "DSC1000011",
    NAME: "Closed",
  },
  REJECTED: {
    ID: "DSC1000012",
    NAME: "Rejected",
  },
  EXPIRED: {
    ID: "DSC1000003",
    NAME: "Expired",
  },
  CANCELLED: {
    ID: "DSC1000007",
    NAME: "Cancelled",
  },
  PENDING_DISBURSEMENT: {
    ID: "DSC1000017",
    NAME: "Pending Disbursement",
  },
};

export const ENQ_STATUS_DISPLAY_NAMES = {
  USM1000007: "New",
  USM1000008: "Pending",
  USM1000001: "Active",
  USM1000006: "Rejected",
};

export const DEAL_CATEGORY_COLUMN_FILTERS = [
  { text: "Invoice Financing", value: "Invoice Financing" },
  { text: "Supply Chain Finance", value: "Supply Chain Finance" },
  { text: "Joint Ventures", value: "Joint Ventures" },
];

export const FINANCING_CATEGORY_COLUMN_FILTERS = [
  { text: "Invoice Financing", value: "Invoice Financing" },
  { text: "Supply Chain Finance", value: "Supply Chain Finance" },
];

export const BUS_STATUS_DISPLAY_NAMES = {
  USM1000001: "Active",
  USM1000002: "Inactive",
  USM1000004: "Delinquent",
  USM1000005: "Deactivated",
  USM1000011: "Blacklist",
};

export const INV_STATUS_DISPLAY_NAMES = {
  USM1000007: "New",
  USM1000001: "Active",
  USM1000005: "Deactivated",
  USM1000002: "Inactive",
};

export const ENT_STATUS_DISPLAY_NAMES = {
  USM1000001: "Pending",
  USM1000002: "Active",
  USM1000004: "Deactivated",
  USM1000006: "Blacklist",
};

export const CREDIT_STATUS_DISPLAY_NAMES = {
  USM1000001: "Pending",
  USM1000002: "Active",
  USM1000004: "Deactivated",
  USM1000003: "Rejected",
};

export const DEAL_STATUS_LABEL_MAP = {
  DSC1000001: "Pending",
  DSC1000002: "Approved",
  DSC1000003: "Expired",
  DSC1000005: "Funded",
  DSC1000006: "Disbursed",
  DSC1000007: "Cancelled",
  DSC1000009: "Partially Settled",
  DSC1000010: "Settled",
  DSC1000011: "Closed",
  DSC1000012: "Rejected",
  DSC1000017: "Pending Disbursement",
};

export const MODAL_WIDTHS = {
  xs: "90%",
  sm: "80%",
  md: "70%",
  lg: "60%",
  xl: "40%",
};

export const ROLE_MODAL_WIDTHS = {
  xs: "90%",
  sm: "80%",
  md: "70%",
};

export const FORM_MODAL_WIDTHS = {
  xs: "90%",
  sm: "80%",
  md: "70%",
  lg: "60%",
};

// Reason Modal title and button name based on action
export const REASON_MODAL_CONFIG = {
  assign: {
    title: TITLE_TXT.ASSIGN_CONFIRM,
    label: "Reason for Assignment",
    btnName: BTN_TXT.SUBMIT,
  },
  reject: {
    title: TITLE_TXT.REJECT_CONFIRM,
    label: "Reason for Rejection",
    btnName: BTN_TXT.SUBMIT,
  },
  reopen: {
    title: TITLE_TXT.REOPEN_CONFIRM,
    label: "Reason for Reopen",
    btnName: BTN_TXT.SUBMIT,
  },
  activate: {
    title: TITLE_TXT.ACTIVATE_CONFIRM,
    label: "Reason for Activation",
    btnName: BTN_TXT.SUBMIT,
  },
  deactivate: {
    title: TITLE_TXT.DEACTIVATE_CONFIRM,
    label: "Reason for Deactivation",
    btnName: BTN_TXT.SUBMIT,
  },
  blacklist: {
    title: TITLE_TXT.BLACKLIST_CONFIRM,
    label: "Reason for Blacklisting",
    btnName: BTN_TXT.SUBMIT,
  },
  deliquent: {
    title: TITLE_TXT.DELINQUENT_CONFIRM,
    label: "Reason for Delinquency",
    btnName: BTN_TXT.SUBMIT,
  },
  cancel: {
    title: TITLE_TXT.CANCEL,
    label: "Reason for Cancellation",
    btnName: BTN_TXT.SUBMIT,
  },
  disburse: {
    title: TITLE_TXT.DISBURSE_CONFIRM,
    label: "Reason for Disbursement",
    btnName: BTN_TXT.SUBMIT,
  },
  republish: {
    label: "Comments",
    btnName: BTN_TXT.SUBMIT,
  },
  agreement: {
    label: "Reason",
    btnName: BTN_TXT.SUBMIT,
  },
};

export const DOC_CONFIG = {
  UTY1000003: [
    {
      key: "kycDirectorsAadhaarDoc",
      title: TITLE_TXT.DIR_AADHAAR,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycDirectorsPanDoc",
      title: TITLE_TXT.DIR_PAN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycGstinDoc",
      title: TITLE_TXT.GSTIN_CERT,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Bank_Statement_12_months",
      title: TITLE_TXT.BANK_STMT_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Audited_Financial_Statement_3_years",
      title: TITLE_TXT.AUD_REPORTS_3_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Sanction_Letter_existing_borrowings",
      title: TITLE_TXT.SANC_LETTER,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Provisional_Financial_Statement_latest_year",
      title: TITLE_TXT.PROV_STMT,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "GST_Returns_12_months",
      title: TITLE_TXT.GST_RETURNS_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "ITR_last_2_years",
      title: TITLE_TXT.ITR_2_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "kycDirectorsPicture",
      title: TITLE_TXT.DIR_PHOTO,
      type: GLOBAL_CONSTANTS.IMAGETYPE,
    },
    {
      key: "others",
      title: TITLE_TXT.OTHER_DOCS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
  ],
  UTY1000004: [
    {
      key: "kycDirectorsAadhaarDoc",
      title: TITLE_TXT.DIR_AADHAAR,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycDirectorsPanDoc",
      title: TITLE_TXT.DIR_PAN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycGstinDoc",
      title: TITLE_TXT.GSTIN_CERT,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Bank_Statement_12_months",
      title: TITLE_TXT.BANK_STMT_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Audited_Financial_Statement_3_years",
      title: TITLE_TXT.AUD_REPORTS_3_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Sanction_Letter_existing_borrowings",
      title: TITLE_TXT.SANC_LETTER,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Provisional_Financial_Statement_latest_year",
      title: TITLE_TXT.PROV_STMT,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "GST_Returns_12_months",
      title: TITLE_TXT.GST_RETURNS_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "ITR_last_2_years",
      title: TITLE_TXT.ITR_2_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "kycDirectorsPicture",
      title: TITLE_TXT.DIR_PHOTO,
      type: GLOBAL_CONSTANTS.IMAGETYPE,
    },
    {
      key: "kycPanDoc",
      title: TITLE_TXT.COMP_PAN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Constitution_Documents",
      title: TITLE_TXT.SOLE_PROP,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Statutory_Reqs_Power_of_Attorney",
      title: TITLE_TXT.STATUTORY_REQ,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Shops_Establishments_Act",
      title: TITLE_TXT.SHOPS_EST,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "others",
      title: TITLE_TXT.OTHER_DOCS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
  ],
  UTY1000005: [
    {
      key: "kycDirectorsAadhaarDoc",
      title: TITLE_TXT.DIR_AADHAAR,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycDirectorsPanDoc",
      title: TITLE_TXT.DIR_PAN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycGstinDoc",
      title: TITLE_TXT.GSTIN_CERT,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Bank_Statement_12_months",
      title: TITLE_TXT.BANK_STMT_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Audited_Financial_Statement_3_years",
      title: TITLE_TXT.AUD_REPORTS_3_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Sanction_Letter_existing_borrowings",
      title: TITLE_TXT.SANC_LETTER,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "Provisional_Financial_Statement_latest_year",
      title: TITLE_TXT.PROV_STMT,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "GST_Returns_12_months",
      title: TITLE_TXT.GST_RETURNS_12_MON,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "ITR_last_2_years",
      title: TITLE_TXT.ITR_2_YEARS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
    {
      key: "kycDirectorsPicture",
      title: TITLE_TXT.DIR_PHOTO,
      type: GLOBAL_CONSTANTS.IMAGETYPE,
    },
    {
      key: "Certificate_of_Incorporation",
      title: TITLE_TXT.CERT_INCORP,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "kycPanDoc",
      title: TITLE_TXT.COMP_PAN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "boardResolution",
      title: TITLE_TXT.BOARD_RESOL,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "KYC_Authorized_Signatory",
      title: TITLE_TXT.KYC_DOCS,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Current_Shareholding_Pattern",
      title: TITLE_TXT.CURR_SHARE_PATTERN,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "Memorandum_and_Articles",
      title: TITLE_TXT.MEMO_ARTICLE,
      type: GLOBAL_CONSTANTS.PDF,
    },
    {
      key: "others",
      title: TITLE_TXT.OTHER_DOCS,
      type: GLOBAL_CONSTANTS.PDF_ZIP,
    },
  ],
};

export const ENT_DOC_CONFIG = [
  {
    key: "entLogo",
    title: TITLE_TXT.ENT_LOGO,
    type: GLOBAL_CONSTANTS.IMAGETYPE,
    allowedTypes: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    maxSizeMB: 5,
  },
  {
    key: "mou",
    title: TITLE_TXT.MOU_SIGN,
    type: GLOBAL_CONSTANTS.PDF,
    allowedTypes: ["application/pdf"],
    maxSizeMB: 20,
  },
];

export const BUS_ENT_DOC_CONFIG = [
  {
    key: "sanction_documents",
    title: TITLE_TXT.SANCTION_DOCS,
    type: GLOBAL_CONSTANTS.ZIP,
    allowedTypes: ["application/zip", "application/x-zip-compressed", "application/octet-stream"],
    maxSizeMB: 20,
  },
];

export const DISPUTE_MODAL_CONFIG = {
  raiseDispute: {
    title: TITLE_TXT.CREATE_NEW_DIS,
    btnName: BTN_TXT.SUBMIT,
  },
  escalate: {
    title: TITLE_TXT.CREATE_NEW_ESC,
    btnName: BTN_TXT.SUBMIT,
  },
  resolve: {
    title: TITLE_TXT.RESOLVE_DIS,
    btnName: BTN_TXT.SUBMIT,
  },
};

export const DOC_TYPE_FRIENDLY_NAMES = {
  DMS1000001: "PAN Card",
  DMS1000002: "GST Certificate",
  DMS1000003: "TAN Certificate",
  DMS1000004: "Cancelled Cheque",
  DMS1000005: "Aadhaar Card",
  DMS1000006: "Driving Licence",
  DMS1000007: "Electricity Bill",
  DMS1000008: "Passport",
  DMS1000009: "Selfie Photograph",
  DMS1000010: "CIN Certificate",
  DMS1000011: "Mobile Verification",
  DMS1000012: "Email Verification",
  DMS1000013: "Bank Account Proof",
  DMS1000014: "Enterprise Logo",
  DMS1000015: "Business Logo",
  DMS1000016: "Director Photograph",
  DMS1000017: "Sanction Documents",
  DMS1000018: "Board Resolution",
  DMS1000019: "Bank Statement",
  DMS1000020: "Audited Financial Statement",
  DMS1000021: "Platform SLA Agreement",
  DMS1000022: "Director Photograph",
  DMS1000023: "Director PAN",
  DMS1000024: "Director Aadhaar",
  DMS1000025: "PAN Document",
  DMS1000026: "PAN Card",
  DMS1000027: "GSTIN Number",
  DMS1000028: "GST Certificate ",
  DMS1000029: "Director PAN",
  DMS1000030: "Director Aadhaar",
  DMS1000031: "Memorandum of Understanding (MOU)",
  DMS1000032: "Bank Statement (Last 12 Months)",
  DMS1000033: "Audited Financial Statements (Last 3 Years)",
  DMS1000034: "Sanction Letter (Existing Borrowings)",
  DMS1000035: "GST Returns (Last 12 Months)",
  DMS1000036: "Financial Summary",
  DMS1000037: "Provisional Financial Statement (Latest Year)",
  DMS1000038: "ITR (Last 2 Years)",
  DMS1000039: "Certificate of Incorporation",
  DMS1000040: "KYC – Authorized Signatory",
  DMS1000041: "Current Shareholding Pattern",
  DMS1000042: "Memorandum & Articles of Association",
  DMS1000043: "Constitution Documents",
  DMS1000044: "Statutory Requirements / Power of Attorney",
  DMS1000045: "Shops & Establishments Act Certificate",
  DMS1000046: "Other Documents",
  DMS1000047: "Financial Ratios",
  DMS1000048: "Financial Evaluation",
  DMS1000049: "Risk Disclosure Agreement",
  DMS1000050: "Transfer of Rights Agreement",
  DMS1000051: "Voter ID",
  DMS1000052: "Passport (Back Side)",
  DMS1000053: "Driving Licence (Back Side)",
  DMS1000055: "Voter ID (Back Side)",
  DMS1000056: "Company PAN Card",
  DMS1000057: "Deal Documents Upload",
  DMS1000054: "Joint Venture NDA",
  DMS1000058: "Joint Venture SLA",
};

export const ENQUIRY_ACTIONS = {
  assign: "assign",
  reject: "reject",
  reopen: "reopen",
  activate: "activate",
};

export const ENQUIRY_SUCCESS_MESSAGES = {
  assign: (name) =>
    `${name} assigned successfully`,

  reject: (name) =>
    `${name} rejected successfully`,

  reopen: (name) =>
    `${name} reopened successfully`,

  activate: (name) =>
    `${name} activated successfully`,

  resendKyc: "KYC link sent successfully",
  KYC_SUBMITTED: "KYC submitted successfully",
  APPROVE_ENQUIRY: "Enquiry approved successfully",
  QUESTIONNAIRE_SENT: "Questionnaire sent successfully",
  QUESTIONNAIRE_SENT_WITH_DEAL: "Questionnaire for Deal Id: {dealId} is sent Successfully",
};

export const DEAL_APPROVAL_SUCCESS_MESSAGES = {
  DEAL_APPROVED: "Deal Id: {dealId} is Approved Successfully",
  DEAL_REJECTED: "Deal Id: {dealId} is Rejected Successfully",
  DEAL_CANCELLED: "Deal Id: {dealId} is Cancelled Successfully",
};

export const getDealApprovalSuccessMessage = (template, dealId) =>
  template.replace("{dealId}", dealId ?? "");

export const BUSINESS_SUCCESS_MESSAGES = {
  deliquent: (name) =>
    `${name} is delinquent successfully`,

  deactivate: (name) =>
    `${name} is deactivated successfully`,

  blacklist: (name) =>
    `${name} is blacklisted successfully`,

  activate: (name) =>
    `${name} is reactivated successfully`,
};

export const ENTERPRISE_SUCCESS_MESSAGES = {
  create: (name) => `${name} created successfully`,
  deactivate: (name) =>
    `${name} is deactivated successfully`,

  activate: (name) =>
    `${name} is reactivated successfully`,

  blacklist: (name) =>
    `${name} is blacklisted successfully`,

  approve: (name) =>
    `${name} is approved successfully`,
};

export const INVESTOR_SUCCESS_MESSAGES = {
  deactivate: (name) =>
    `${name} is deactivated successfully`,

  activate: (name) =>
    `${name} is activated successfully`,
};

export const FIN_TEMPLATE_CONFIG = {
  financialEvaluation: {
    sheets: {
      "Revenue and Profitability": [
        "Year",
        "Revenue",
        "PAT",
        "EBITDA",
        "Margins",
      ],

      Leverage: [
        "Year",
        "Equity",
        "Debt",
        "Leverage",
      ],

      Liquidity: [
        "Year",
        "CashAndEquivalents",
        "Payables",
        "Receivables",
        "Current Ratio",
      ],
    },
  },

  financialSummary: {
    sheets: {
      "Financial Summary": [
        "Year",
        "NetOwnedFunds",
        "LongTermBorrowing",
        "CurrentAssets",
        "CurrentLiabilities",
        "RevenueinINRYoY",
        "EBITDA",
        "NetProfit",
      ],
    },
  },

  ratios: {
    sheets: {
      Ratios: [
        "Year",
        "DebtEquityRatio",
        "QuickRatio",
        "CurrentRatio",
        "DebServiceCoverageRatio",
        "NetProfitMargin",
        "TOLTNW",
      ],
    },
  },
};

export const FILE_TYPES = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "zip"
];
